import React, { useEffect, useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, Chip, CircularProgress, Divider, FormControl, FormHelperText, ListItemText, MenuItem, Select, Stack, Switch, TextField, Typography } from '@mui/material'
import CommonHeader from '../../CommonComponents/CommonHeader'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useParams } from 'react-router-dom';
import { showErrorToast, showSuccessToast } from '../../toastUtils';
import ButtonCommon from '../../CommonComponents/ButtonCommon';
import RichTextComponent from '../../CommonComponents/RichTextComponent';
import CustomSwitch from '../../CommonComponents/CustomSwitch';
import countries from "world-countries";
import { createFrameworks, getFrameworkById, updateFrameworks } from '../../api/framework';
import { getAllLanguages } from '../../api/language';
import CustomBreadcrumb from '../../CommonComponents/CommonBreadcrumb';
// import { getAllLanguages } from '../../api/framework';

const countryListData = countries
    .map(country => ({
        name: country.name.common,
        flag: country.flag,
        code: country.cca2
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

export default function FrameworkCreateOrViewPage() {
    const [formData, setFormData] = useState({
        frameworkName: "",
        supportedLanguage: [],
        countryList: [],
        description: "",
        bannerName: "",
        target: "WorldWide",
        bannerTitle: "",
        bannerDescription: "",
        bannerLayout: "Cloud",
        bannerPosition: "Middle Center",
        bannerConsentButtonPlacement: "Inline",
        swapButton: false,
        bannerAcceptAllText: "Accept All",
        bannerShowAcceptAll: true,
        bannerAcceptNecessaryText: "Reject All",
        bannerShowAcceptNecessary: true,
        bannerManagePreferencesText: "Manage Preferences",
        bannerShowManagePreferences: true,
        enablePrivacyTriggerPosition: true,
        privacyTriggerPosition: 'Bottom Left',
        controlLevel: 'Category & Services',
        displayCookiesAndServices: true,
        managePreferenceContentTitle: '',
        managePreferenceContentDescription: '',
        managePreferenceContentMoreInformationTitle: '',
        managePreferenceContentMoreInformation: '',
        preferencesModalLayout: 'Box',
        preferencesModalVerticalAlignment: 'Left',
        preferencesModalButtonAcceptAll: 'Accept All',
        preferencesModalButtonShowAcceptAll: true,
        preferencesModalButtonAcceptNecessary: 'Reject All',
        preferencesModalButtonShowAcceptNecessary: true,
        preferencesModalButtonSavePreferences: 'Save Preferences',
        preferencesModalButtonShowSavePreferences: true
    });
    const navigate = useNavigate();
    const { id } = useParams();
    // const [initialData, setInitialData] = useState({})
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(id ? true : false);
    const [isEdited, setIsEdited] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [allLanguage, setAllLanguage] = useState([]);
    const [languageLoading, setLanguageLoading] = useState(false);
    const [activeFramework, setActiveFramework] = useState(true);

    useEffect(() => {
        const fetchAllLanguage = async () => {
            setLanguageLoading(true)
            try {
                const response = await getAllLanguages(1, 500)

                if (response.success && response.data) {
                    const data = response.data.data
                        .filter(lan => lan.status === 'active')
                        .sort((a, b) => a.language_description.localeCompare(b.language_description));
                    setAllLanguage(data)
                }
            } catch (err) {
                console.log(err);
            } finally {
                setLanguageLoading(false)
            }
        }

        fetchAllLanguage()
    }, [])

    useEffect(() => {
        const fetchDetails = async () => {
            if (id) {
                setLoading(true)
                try {
                    const response = await getFrameworkById(id);
                    if (response.success) {
                        const frameworkData = response.data;
                        // setInitialData(frameworkData)
                        setFormData({
                            frameworkName: frameworkData?.framework_name || '',
                            supportedLanguage: frameworkData?.supported_languages || [],
                            countryList: frameworkData?.country_list || [],
                            description: frameworkData?.framework_description || "",
                            bannerName: frameworkData?.framework_properties?.name || "",
                            target: frameworkData?.framework_properties?.target_type || "WorldWide",
                            bannerTitle: frameworkData?.framework_properties?.consent_title || "",
                            bannerDescription: frameworkData?.framework_properties?.consent_description || "",
                            bannerLayout: frameworkData?.framework_properties?.consent_layout || "Cloud",
                            bannerPosition: frameworkData?.framework_properties?.floating_preferences_icon_position || "Middle Center",
                            bannerConsentButtonPlacement: frameworkData?.framework_properties?.consent_button_placement || "Inline",
                            swapButton: frameworkData?.framework_properties?.swap_buttons,
                            bannerAcceptAllText: frameworkData?.framework_properties?.banner_accept_btn_text || "Accept All",
                            bannerShowAcceptAll: frameworkData?.framework_properties?.show_banner_accept_btn,
                            bannerAcceptNecessaryText: frameworkData?.framework_properties?.banner_accept_necessary_btn_text || "Reject All",
                            bannerShowAcceptNecessary: frameworkData?.framework_properties?.show_banner_accept_necessary_btn,
                            bannerManagePreferencesText: frameworkData?.framework_properties?.banner_preferences_btn_text || "Manage Preferences",
                            bannerShowManagePreferences: frameworkData?.framework_properties?.show_banner_preferences_btn,
                            enablePrivacyTriggerPosition: frameworkData?.framework_properties?.show_floating_preferences_icon,
                            privacyTriggerPosition: 'Bottom Left',
                            controlLevel: frameworkData?.framework_properties?.preferences_control_level || 'Category & Services',
                            displayCookiesAndServices: frameworkData?.framework_properties?.show_services,
                            managePreferenceContentTitle: frameworkData?.framework_properties?.settings_title || '',
                            managePreferenceContentDescription: frameworkData?.framework_properties?.settings_description || '',
                            managePreferenceContentMoreInformationTitle: frameworkData?.framework_properties?.settings_more_info_title || '',
                            managePreferenceContentMoreInformation: frameworkData?.framework_properties?.settings_more_info || '',
                            preferencesModalLayout: frameworkData?.framework_properties?.settings_layout || 'Box',
                            preferencesModalVerticalAlignment: frameworkData?.framework_properties?.settings_position_x || 'Left',
                            preferencesModalButtonAcceptAll: frameworkData?.framework_properties?.preferences_accept_btn_text || 'Accept All',
                            preferencesModalButtonShowAcceptAll: frameworkData?.framework_properties?.show_preferences_accept_btn,
                            preferencesModalButtonAcceptNecessary: frameworkData?.framework_properties?.preferences_accept_necessary_btn_text || 'Reject All',
                            preferencesModalButtonShowAcceptNecessary: frameworkData?.framework_properties?.show_preferences_accept_necessary_btn,
                            preferencesModalButtonSavePreferences: frameworkData?.framework_properties?.save_preferences_btn_text || 'Save Preferences',
                            preferencesModalButtonShowSavePreferences: frameworkData?.framework_properties?.show_save_preferences_btn
                        });
                        setActiveFramework(frameworkData?.is_deleted ? false : true)
                    }
                } catch (error) {
                    console.error("Failed to fetch organization:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchDetails();
    }, [id]);

    // const handleChange = (name, value) => {
    //     setFormData((prev) => ({
    //         ...prev,
    //         [name]: value,
    //     }));

    //     if (errors[name]) {
    //         setErrors((prev) => ({
    //             ...prev,
    //             [name]: null,
    //         }));
    //     }

    //     setIsEdited(true)
    // };
    const handleChange = (name, value) => {
        setFormData((prev) => {
            const updatedForm = {
                ...prev,
                [name]: value,
            };

            if (name === "bannerLayout") {
                updatedForm.bannerPosition = value === "Bar" ? "Top" : "Middle Center";
            }

            return updatedForm;
        });

        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: null,
            }));
        }

        setIsEdited(true);
    };


    const validate = () => {
        const newErrors = {};

        // Required text fields
        if (!formData.frameworkName?.trim()) {
            newErrors.frameworkName = "Framework name is required";
        }

        if (!Array.isArray(formData.supportedLanguage) || formData.supportedLanguage.length === 0) {
            newErrors.supportedLanguage = "At least one country must be selected";
        }

        if (!Array.isArray(formData.countryList) || formData.countryList.length === 0) {
            newErrors.countryList = "At least one country must be selected";
        }

        if (!formData.description?.trim() || formData.description === '<p></p>') {
            newErrors.description = "Description is required";
        }

        if (!formData.bannerName?.trim()) {
            newErrors.bannerName = "Banner name is required";
        }

        if (!formData.bannerTitle?.trim()) {
            newErrors.bannerTitle = "Banner title is required";
        }

        if (!formData.bannerDescription?.trim() || formData.bannerDescription === '<p></p>') {
            newErrors.bannerDescription = "Banner description is required";
        }

        // Dropdown/select required
        if (!formData.target?.trim()) {
            newErrors.target = "Target selection is required";
        }

        if (!formData.bannerLayout?.trim()) {
            newErrors.bannerLayout = "Banner layout is required";
        }

        if (!formData.bannerPosition?.trim()) {
            newErrors.bannerPosition = "Banner position is required";
        }

        if (!formData.bannerConsentButtonPlacement?.trim()) {
            newErrors.bannerConsentButtonPlacement = "Consent button placement is required";
        }

        if (!formData.controlLevel?.trim()) {
            newErrors.controlLevel = "Control level is required";
        }

        if (!formData.privacyTriggerPosition?.trim()) {
            newErrors.privacyTriggerPosition = "Privacy trigger position is required";
        }

        if (!formData.preferencesModalLayout?.trim()) {
            newErrors.preferencesModalLayout = "Preferences modal layout is required";
        }

        if (!formData.preferencesModalVerticalAlignment?.trim()) {
            newErrors.preferencesModalVerticalAlignment = "Vertical alignment is required";
        }

        // Optional but required if shown
        if (formData.bannerShowAcceptAll && !formData.bannerAcceptAllText?.trim()) {
            newErrors.bannerAcceptAllText = "Accept All text is required";
        }

        if (formData.bannerShowAcceptNecessary && !formData.bannerAcceptNecessaryText?.trim()) {
            newErrors.bannerAcceptNecessaryText = "Reject All text is required";
        }

        if (formData.bannerShowManagePreferences && !formData.bannerManagePreferencesText?.trim()) {
            newErrors.bannerManagePreferencesText = "Manage Preferences text is required";
        }

        if (formData.preferencesModalButtonShowAcceptAll && !formData.preferencesModalButtonAcceptAll?.trim()) {
            newErrors.preferencesModalButtonAcceptAll = "Accept All (modal) text is required";
        }

        if (formData.preferencesModalButtonShowAcceptNecessary && !formData.preferencesModalButtonAcceptNecessary?.trim()) {
            newErrors.preferencesModalButtonAcceptNecessary = "Reject All (modal) text is required";
        }

        if (formData.preferencesModalButtonShowSavePreferences && !formData.preferencesModalButtonSavePreferences?.trim()) {
            newErrors.preferencesModalButtonSavePreferences = "Save Preferences text is required";
        }

        // Optional content checks
        if (!formData.managePreferenceContentTitle || !formData.managePreferenceContentTitle.trim()) {
            newErrors.managePreferenceContentTitle = "Title is required";
        }

        if (!formData.managePreferenceContentDescription || !formData.managePreferenceContentDescription.trim()) {
            newErrors.managePreferenceContentDescription = "Description is required";
        }

        if (!formData.managePreferenceContentMoreInformationTitle || !formData.managePreferenceContentMoreInformationTitle.trim()) {
            newErrors.managePreferenceContentMoreInformationTitle = "More Inforamation Title is required";
        }

        if (!formData.managePreferenceContentMoreInformation || !formData.managePreferenceContentMoreInformation.trim()) {
            newErrors.managePreferenceContentMoreInformation = "More Inforamation is required";
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFrameworkSwitchChange = (e) => {
        setActiveFramework(e.target.checked);
        setIsEdited(true)
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        const payload = {
            framework_name: formData.frameworkName,
            framework_description: formData.description,
            supported_languages: formData.supportedLanguage,
            is_mandatory_to_trans: false, // static
            country_list: formData.countryList,
            state_list: [
                "GJ"
            ], //static
            framework_properties: {
                name: formData.bannerName || "Default Banner > INDIA",
                enabled: true,
                dark_mode: "light",
                target_type: formData.target || "WorldWide",
                swap_buttons: formData.swapButton,
                button_colors: {
                    bg: "#FFFFFF",
                    link_color: "#FFFFFF",
                    text_color: "#717171",
                    heading_color: "#333333",
                    btn_primary_bg: "#717171",
                    dark_mode_link: "#FFFFFF",
                    dark_mode_text: "#717171",
                    btn_primary_color: "#333333",
                    dark_mode_heading: "#333333",
                    secondary_button_bg: "#717171",
                    dark_mode_background: "#FFFFFF",
                    secondary_button_text: "#FFFFFF",
                    dark_mode_primary_button_bg: "#FFFFFF",
                    dark_mode_primary_button_text: "#333333",
                    dark_mode_secondary_button_bg: "#717171",
                    dark_mode_secondary_button_text: "#FFFFFF"
                },
                consent_title: formData.bannerTitle || "We value your privacy >> Italy,India",
                logo_url_dark: "",
                show_services: formData.displayCookiesAndServices,
                consent_layout: formData.bannerLayout || "Box",
                forced_consent: false,
                logo_url_light: "",
                settings_title: formData.managePreferenceContentTitle || "Cookie Usage",
                settings_layout: formData.preferencesModalLayout || "Box",
                consent_position: formData.bannerPosition || "Bottom Center",
                btn_border_radius: "2.0",
                settings_more_info: formData.managePreferenceContentMoreInformation || "For any queries in relation to our policy on cookies and your choices, please contact us.",
                consent_description: formData.bannerDescription || "<p class=\"paragraph\">We use cookies to enhance your browsing experience, serve personalised ads or content, and analyse our traffic. By clicking \"Accept All\", you consent to our use of cookies.</p>",
                modal_border_radius: "1.5",
                settings_position_x: formData.preferencesModalVerticalAlignment || "Left",
                equal_weight_buttons: true,
                settings_description: formData.managePreferenceContentDescription || "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose to accept cookies or opt-out whenever you want. For more details, read the full privacy policy.",
                consent_duration_days: "182",
                banner_accept_btn_text: formData.bannerAcceptAllText || "Accept All",
                show_banner_accept_btn: formData.bannerShowAcceptAll,
                consent_button_placement: formData.bannerConsentButtonPlacement || "Inline",
                settings_more_info_title: formData.managePreferenceContentMoreInformationTitle || "More Information",
                preferences_control_level: formData.controlLevel || "Category & Services",
                save_preferences_btn_text: formData.preferencesModalButtonSavePreferences || "Save Preference",
                show_save_preferences_btn: formData.preferencesModalButtonShowSavePreferences,
                banner_preferences_btn_text: formData.bannerManagePreferencesText || "Manage Preference",
                preferences_accept_btn_text: formData.preferencesModalButtonAcceptAll || "Accept All",
                show_banner_preferences_btn: formData.preferencesModalButtonShowSavePreferences,
                show_preferences_accept_btn: formData.preferencesModalButtonShowAcceptAll,
                consent_additional_description: "Concent Management Powered By Data Privacy Cloud",
                show_floating_preferences_icon: formData.enablePrivacyTriggerPosition,
                banner_accept_necessary_btn_text: formData.bannerAcceptNecessaryText || "Reject All",
                show_banner_accept_necessary_btn: formData.bannerShowAcceptNecessary,
                floating_preferences_icon_position: formData.privacyTriggerPosition || "Bottom Left",
                preferences_accept_necessary_btn_text: formData.preferencesModalButtonAcceptNecessary || "Reject All",
                show_preferences_accept_necessary_btn: formData.preferencesModalButtonShowAcceptNecessary
            },
            is_deleted: !activeFramework
        }

        setIsSaving(true);
        try {
            let response;

            if (id) {
                // Editing existing organization
                response = await updateFrameworks(id, payload);
            } else {
                // Creating new organization
                response = await createFrameworks(payload);
            }

            if (response?.success) {
                showSuccessToast(response.message);
                navigate('/master/frameworks');
            } else {
                showErrorToast(response?.message || "Failed to submit framework data.");
            }
        } catch (error) {
            console.error("Organization submission error:", error);
            const serverMsg = error?.message;
            showErrorToast(serverMsg || "Something went wrong. Please try again.");
        } finally {
            setIsSaving(false);
            setIsEdited(false)
        }
    };

    const targetingOptions = [
        {
            id: "WorldWide",
            label: "WorldWide",
            description:
                "Show the banner to all visitors, regardless of their location.",
        },
        // {
        //     id: "Country",
        //     label: "Selected Country",
        //     description:
        //         "Show the banner to all visitors, regardless of their location.",
        // },
        // {
        //   id: "SelectedUSStates",
        //   label: "Selected US States",
        //   description: "Show the banner only to visitors in selected US states.",
        // },
    ];

    const TargetButton = ({ option }) => {
        const isSelected = formData.target === option.id;
        // let isDisable = false;
        // if (option.id === "Country") {
        //     isDisable = !licenseData.plan.plan_attributes.geo_location;
        // }

        return (
            <Box sx={{
                flex: 1,
                position: "relative",
                // opacity: isDisable ? 0.5 : 1
            }}>
                <Button
                    fullWidth
                    variant="outlined"
                    name='targeting'
                    // disabled={isDisable}
                    onClick={() => handleChange("target", option.id)}
                    // onClick={() => {
                    // handleInputChange("targeting", option.id);
                    // Open the modal to select countries

                    // if (option.id === "Country") {
                    //     setIsCountrySelectOption("Country");
                    // } else {
                    //     setIsCountrySelectOption(null);
                    // }
                    // }}
                    sx={{
                        borderColor: isSelected ? "#F15A29" : "#E0E0E0",
                        color: isSelected ? "##F15A29" : "#525455",
                        backgroundColor: "white",
                        "&:hover": {
                            borderColor: isSelected ? "#F15A29" : "#B0B9C5",
                            backgroundColor: "white",
                        },
                        textTransform: "none",
                        fontWeight: isSelected ? 600 : 400,
                        padding: "12px 16px",
                        borderRadius: "8px",
                        border: isSelected ? "2px solid #F15A29" : "1px solid #E0E0E0",
                        minHeight: "48px",
                        minWidth: "200px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        gap: 1,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: isSelected ? 600 : 600,
                            color: isSelected ? "#F15A29" : "#525455",
                        }}
                    >
                        {option.label}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#637381",
                            fontSize: "12px",
                            textAlign: "left",
                            fontWeight: 400,
                        }}
                    >
                        {option.description}
                    </Typography>
                </Button>
            </Box>
        );
    };

    const breadcrumbItems = [
        {
            text: "Framework",
            href: "/master/frameworks",
            onClick: () => navigate("/master/frameworks"),
        },
        {
            text: id ? "View" : "Create"
        },
    ];

    const layoutOptions = [
        {
            key: "Box",
            description: "Banner appears as a compact box",
        },
        {
            key: "Cloud",
            description: "Banner appears as a wider banner",
        },
        {
            key: "Bar",
            description: "Banner appears as a full width bar",
        },
    ];

    if (loading) {
        return (
            <Box sx={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress />
            </Box>
        )
    }

    return (
        <Box>
            {/* common back button */}
            <CustomBreadcrumb
                items={breadcrumbItems}
                onBackClick={() => {
                    navigate("/master/frameworks");
                }}
            />
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 4 }}>
                <CommonHeader
                    title={`${id ? 'View' : 'Create'} Framework`}
                    subTitle={`You can ${id ? 'view and edit' : 'create'} the organizations on this page.`}
                />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            padding: 1,
                            height: '50px'
                        }}
                    >
                        <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600, color: "#525455" }}
                        >
                            Activate
                        </Typography>
                        <Switch
                            color="primary"
                            checked={activeFramework}
                            onChange={handleFrameworkSwitchChange}
                        />
                    </Box>
                    <ButtonCommon onClick={handleSubmit} disabled={!isEdited}>
                        {id ? isSaving ? 'Updating...' : 'Update' : isSaving ? 'Saving...' : 'Save'}
                    </ButtonCommon>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                {/* Framework */}
                <Accordion defaultExpanded sx={{ bgcolor: '#F9FAFB', width: '100%' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '& .MuiAccordionSummary-content': { margin: '4px 0' },
                        }}>
                        <Typography variant="h6" sx={{ fontSize: '18px' }}>
                            Framework
                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ width: '100%' }}>
                                <FormControl fullWidth error={!!errors.frameworkName} sx={{ mb: 2 }}>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Framework Name
                                        <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                    </Typography>

                                    <TextField
                                        value={formData.frameworkName}
                                        onChange={(e) => handleChange('frameworkName', e.target.value)}
                                        placeholder="Enter Your Framework Name"
                                        variant="outlined"
                                        size="small"
                                        sx={{ bgcolor: '#fff' }}
                                    />
                                    {errors.frameworkName && <FormHelperText>{errors.frameworkName}</FormHelperText>}
                                </FormControl>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                                <FormControl fullWidth size="small" error={!!errors.supportedLanguage} sx={{ mb: 2 }}>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Supported Language
                                        <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                    </Typography>
                                    <Select
                                        multiple
                                        displayEmpty
                                        value={formData.supportedLanguage}
                                        onChange={(e) => handleChange('supportedLanguage', e.target.value)}
                                        renderValue={(selected) => {
                                            if (!selected || selected.length === 0) {
                                                return <Typography sx={{ color: "#727273" }}>Select Language</Typography>;
                                            }
                                            return (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                    {selected.map((value) => (
                                                        <Chip
                                                            key={value}
                                                            label={allLanguage?.find(lang => lang.language_code === value)?.language_description}
                                                            size="small"
                                                            sx={{ bgcolor: '#FFEFEA', color: '#727273' }}
                                                            onMouseDown={(event) => event.stopPropagation()}
                                                            onDelete={(event) => {
                                                                event.stopPropagation();
                                                                const updatedList = formData.supportedLanguage.filter((item) => item !== value);
                                                                handleChange('supportedLanguage', updatedList);
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            );
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}
                                    >
                                        {languageLoading ? <MenuItem sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress size={20} /></MenuItem> :
                                            (allLanguage && allLanguage.length > 0 ? (
                                                allLanguage.map((lang) => (
                                                    <MenuItem key={lang.language_code} value={lang.language_code}>
                                                        {lang.language_description}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>No languages available</MenuItem>
                                            ))}
                                    </Select>
                                    {errors.supportedLanguage && <FormHelperText>{errors.supportedLanguage}</FormHelperText>}
                                </FormControl>

                                <FormControl
                                    fullWidth
                                    size="small"
                                    error={!!errors.countryList}
                                >
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Country List
                                        <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                    </Typography>
                                    <Select
                                        multiple
                                        displayEmpty
                                        value={formData.countryList}
                                        onChange={(e) => handleChange('countryList', e.target.value)}
                                        renderValue={(selected) => {
                                            if (!selected || selected.length === 0) {
                                                return <Typography sx={{ color: "#727273" }}>Select Country</Typography>;
                                            }
                                            return (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                    {selected.map((value) => (
                                                        <Chip
                                                            key={value}
                                                            label={countryListData?.find(country => country.code === value).name}
                                                            size="small"
                                                            sx={{ bgcolor: '#FFEFEA', color: '#727273' }}
                                                            onMouseDown={(event) => event.stopPropagation()}
                                                            onDelete={(event) => {
                                                                event.stopPropagation();
                                                                const updatedList = formData.countryList.filter((item) => item !== value);
                                                                handleChange('countryList', updatedList);
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            );
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}
                                    >
                                        {countryListData && countryListData.length > 0 ? (
                                            countryListData.map((country) => (
                                                <MenuItem key={country.code} value={country.code}>
                                                    <ListItemText primary={country.name} />
                                                </MenuItem>
                                            ))
                                        ) : (
                                            <MenuItem disabled>No languages available</MenuItem>
                                        )}
                                    </Select>

                                    {errors?.countryList && (
                                        <FormHelperText variant="error">
                                            {errors.countryList}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Box>
                        </Box>
                        <FormControl fullWidth error={!!errors.description}>
                            <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                Description
                                <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                            </Typography>
                            <TextField
                                name="description"
                                value={formData.description}
                                onChange={(e) => handleChange('description', e.target.value)}
                                placeholder="Enter Your Description"
                                variant="outlined"
                                size="small"
                                multiline
                                minRows={1}  // Minimum 1 row
                                maxRows={3}  // Maximum 3 rows
                                sx={{ bgcolor: '#fff' }}
                            />
                            {errors.description && <FormHelperText>{errors.description}</FormHelperText>}
                        </FormControl>
                    </AccordionDetails>
                </Accordion>

                {/* Banner */}
                <Accordion sx={{ bgcolor: '#F9FAFB', width: '100%' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '& .MuiAccordionSummary-content': { margin: '4px 0' },
                        }}>
                        <Typography sx={{ fontSize: '18px' }}>
                            Banner
                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Card
                                variant="outlined"
                                sx={{ bgcolor: "#F9FAFB", overflow: "unset" }}
                            >
                                <CardContent sx={{ p: 3, overflow: "unset" }}>
                                    <Typography gutterBottom sx={{ mb: 2, fontSize: '18px' }}>
                                        Basic
                                        {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                    </Typography>
                                    <FormControl fullWidth error={!!errors.bannerName} sx={{ mb: 2 }}>
                                        <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                            Banner Name
                                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                        </Typography>

                                        <TextField
                                            value={formData.bannerName}
                                            onChange={(e) => handleChange('bannerName', e.target.value)}
                                            placeholder="Enter Banner Name"
                                            variant="outlined"
                                            size="small"
                                            sx={{ bgcolor: '#fff' }}
                                        />
                                        {errors.bannerName && <FormHelperText>{errors.bannerName}</FormHelperText>}
                                    </FormControl>
                                </CardContent>
                            </Card>

                            <Card
                                variant="outlined"
                                sx={{ bgcolor: "#F9FAFB", overflow: "unset" }}
                            >
                                <CardContent sx={{ p: 3, overflow: "unset" }}>
                                    <Typography gutterBottom sx={{ mb: 2, fontSize: '18px' }}>
                                        Targeting
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        mb={2}
                                    >
                                        Note: Selecting the same regions as other banners will
                                        automatically deselect those regions from the corresponding
                                        banners. If there are mulitple banners targetting "worldwide",
                                        the last banner to be saved will be the one that is shown.
                                    </Typography>

                                    {/* Buttons Container */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: 2,
                                            "& > *": {
                                                flex: 1,
                                            }, // Make each button container take equal space
                                        }}
                                    >
                                        {targetingOptions.map((option) => (
                                            <TargetButton key={option.id} option={option} />
                                        ))}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {/* Banner Content */}
                <Accordion sx={{ bgcolor: '#F9FAFB', width: '100%' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '& .MuiAccordionSummary-content': { margin: '4px 0' },
                        }}>
                        <Typography sx={{ fontSize: '18px' }}>
                            Banner Content
                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <FormControl fullWidth error={!!errors.bannerTitle} sx={{ mb: 2 }}>
                                <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                    Title
                                    <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                </Typography>

                                <TextField
                                    value={formData.bannerTitle}
                                    onChange={(e) => handleChange('bannerTitle', e.target.value)}
                                    placeholder="We Use Cookies"
                                    variant="outlined"
                                    size="small"
                                    sx={{ bgcolor: '#fff' }}
                                />
                                {errors.bannerTitle && <FormHelperText>{errors.bannerTitle}</FormHelperText>}
                            </FormControl>

                            <FormControl fullWidth error={!!errors.bannerDescription} sx={{ mb: 2 }}>
                                <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                    Description
                                    <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                </Typography>

                                <RichTextComponent
                                    name="bannerDescription"
                                    value={formData.bannerDescription}
                                    // handleInputChange={(e) => handleChange('bannerDescription', e.target.value)}
                                    handleInputChange={handleChange}
                                />
                                {errors.bannerDescription && <FormHelperText>{errors.bannerDescription}</FormHelperText>}
                            </FormControl>

                            <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                {/* Layout Section */}
                                <Box>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Layout
                                        {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                    </Typography>
                                    <Card>
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(3, 1fr)",
                                                    gap: 2,
                                                    width: "100%",
                                                }}
                                            >
                                                {layoutOptions.map((option) => {
                                                    const isSelected = formData.bannerLayout === option.key;
                                                    return (
                                                        <Button
                                                            key={option}
                                                            variant="outlined"
                                                            onClick={() => handleChange('bannerLayout', option.key)}
                                                            sx={{
                                                                backgroundColor: isSelected ? "#ff634814" : "#FFFFFF",
                                                                "&:hover": {
                                                                    backgroundColor: isSelected ? "#ff634814" : "#F9FAFB",
                                                                    borderColor: isSelected ? "#FF6348" : "#B0B9C5",
                                                                },
                                                                textTransform: "none",
                                                                height: "90px", // Increased height to accommodate description
                                                                fontSize: "16px",
                                                                borderRadius: "8px",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                gap: "4px",
                                                                padding: "12px",
                                                                // width: "200px",
                                                                border: isSelected ? "1px solid #FF6348" : "1px solid #E5E7EB",
                                                                "&.Mui-selected": {
                                                                    backgroundColor: "#F0FDF9",
                                                                    borderColor: "#00B894",
                                                                },
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="subtitle1"
                                                                component="div"
                                                                sx={{
                                                                    color: isSelected ? "#FF6348" : "#525455",
                                                                    fontWeight: isSelected ? 600 : 400,
                                                                }}
                                                            >
                                                                {option.key}
                                                            </Typography>
                                                            <Typography
                                                                variant="caption"
                                                                component="div"
                                                                sx={{
                                                                    textAlign: "center",
                                                                    color: isSelected ? "#FF6348" : "#717171",
                                                                    fontSize: "12px",
                                                                    lineHeight: 1.2,
                                                                }}
                                                            >
                                                                {option.description}
                                                            </Typography>
                                                        </Button>
                                                    )
                                                })}
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>

                                {/* Position Section */}
                                <Box>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Banner Position
                                        {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                    </Typography>
                                    <Card>
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        formData.bannerLayout === "Bar"
                                                            ? "repeat(2, 1fr)"
                                                            : "repeat(3, 1fr)",
                                                    gap: 2,
                                                    width: "100%",
                                                }}
                                            >
                                                {formData.bannerLayout === "Bar"
                                                    ? // Position options for Bar layout
                                                    ["Top", "Bottom"].map((position) => {
                                                        const isSelected = formData.bannerPosition === position
                                                        return (
                                                            <Button
                                                                key={position}
                                                                variant="outlined"
                                                                onClick={() =>
                                                                    handleChange('bannerPosition', position)
                                                                }
                                                                sx={{
                                                                    borderColor: isSelected ? "#FF6348" : "#E5E7EB",
                                                                    color: isSelected ? "#FF6348" : "#525455",
                                                                    backgroundColor: isSelected ? "#ff634814" : "#FFFFFF",
                                                                    "&:hover": {
                                                                        backgroundColor: isSelected ? "#ff634814" : "#F9FAFB",
                                                                        borderColor: isSelected ? "#FF6348" : "#B0B9C5",
                                                                    },
                                                                    textTransform: "none",
                                                                    height: "60px",
                                                                    fontSize: "16px",
                                                                    borderRadius: "8px",
                                                                }}
                                                            >
                                                                {position}
                                                            </Button>
                                                        )
                                                    })
                                                    : // Position options for Box and Cloud layouts
                                                    [
                                                        "Top Left",
                                                        "Top Center",
                                                        "Top Right",
                                                        "Middle Left",
                                                        "Middle Center",
                                                        "Middle Right",
                                                        "Bottom Left",
                                                        "Bottom Center",
                                                        "Bottom Right",
                                                    ].map((position) => {
                                                        const isSelected = formData.bannerPosition === position
                                                        return (
                                                            <Button
                                                                key={position}
                                                                variant="outlined"
                                                                onClick={() =>
                                                                    handleChange('bannerPosition', position)
                                                                }
                                                                sx={{
                                                                    borderColor: isSelected ? "#FF6348" : "#E5E7EB",
                                                                    color: isSelected ? "#FF6348" : "#525455",
                                                                    backgroundColor: isSelected ? "#ff634814" : "#FFFFFF",
                                                                    "&:hover": {
                                                                        backgroundColor: isSelected ? "#ff634814" : "#F9FAFB",
                                                                        borderColor: isSelected ? "#FF6348" : "#B0B9C5",
                                                                    },
                                                                    textTransform: "none",
                                                                    height: "60px",
                                                                    fontSize: "16px",
                                                                    borderRadius: "8px",
                                                                }}
                                                            >
                                                                {/* {position.replace(/([A-Z])/g, " $1").trim()} */}
                                                                {position}
                                                            </Button>
                                                        )
                                                    })}
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>

                                {/* Consent Button Placement Section - Only show for Bar and Cloud layouts */}
                                {formData.layout !== "Box" && (
                                    <Box>
                                        <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                            Consent Button Placement
                                            {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(3, 1fr)",
                                                gap: 2,
                                                width: "100%",
                                            }}
                                        >
                                            {["Stacked", "Inline", "Row"].map((placement) => {
                                                const isSelected = formData.bannerConsentButtonPlacement === placement
                                                return (
                                                    <Button
                                                        key={placement}
                                                        variant="outlined"
                                                        onClick={() =>
                                                            handleChange('bannerConsentButtonPlacement', placement)
                                                        }
                                                        sx={{
                                                            borderColor: isSelected ? "#FF6348" : "#E5E7EB",
                                                            color: isSelected ? "#FF6348" : "#525455",
                                                            backgroundColor: isSelected ? "#ff634814" : "#FFFFFF",
                                                            "&:hover": {
                                                                backgroundColor: isSelected ? "#ff634814" : "#F9FAFB",
                                                                borderColor: isSelected ? "#FF6348" : "#B0B9C5",
                                                            },
                                                            textTransform: "none",
                                                            height: "60px",
                                                            fontSize: "16px",
                                                            borderRadius: "8px",
                                                        }}
                                                    >
                                                        {placement}
                                                    </Button>
                                                )
                                            })}
                                        </Box>
                                    </Box>
                                )}

                                {/* Banner Buttons */}
                                <Box>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Banner Buttons
                                        {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                    </Typography>
                                    <Card
                                        variant="outlined"
                                        sx={{
                                            border: "1px solid #E5E7EB",
                                            borderRadius: "12px",
                                        }}
                                    >
                                        <CardContent sx={{ p: 3 }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                {/* Swap Buttons Section */}
                                                <Box>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <Box>
                                                            <Typography
                                                                sx={{ color: "#525455" }}
                                                            >
                                                                Swap Buttons
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#6B7280" }}>
                                                                Flip the position of the buttons.
                                                            </Typography>
                                                        </Box>
                                                        <CustomSwitch
                                                            checked={formData.swapButton}
                                                            onChange={(e) =>
                                                                handleChange('swapButton', e.target.checked)
                                                            }
                                                        />
                                                    </Box>
                                                </Box>

                                                <Divider sx={{ my: 1 }} />

                                                {/* Customizable Button Sections */}
                                                {[
                                                    {
                                                        title: "Accept All",
                                                        subtitle: "Consent to all categories",
                                                        showField: "bannerShowAcceptAll",
                                                        field: "bannerAcceptAllText",
                                                        defaultText: "Accept All",
                                                        required: true,
                                                    },
                                                    {
                                                        title: "Accept necessary",
                                                        subtitle: "Consent to only necessary cookie",
                                                        showField: "bannerShowAcceptNecessary",
                                                        field: "bannerAcceptNecessaryText",
                                                        defaultText: "Reject All",
                                                        required: false,
                                                    },
                                                    {
                                                        title: "Manage Preferences",
                                                        subtitle: "Open model to customise & learn more about cookie usage",
                                                        showField: "bannerShowManagePreferences",
                                                        field: "bannerManagePreferencesText",
                                                        defaultText: "Manage Preferences",
                                                        required: true,
                                                    },
                                                ].map((item, index) => (
                                                    <React.Fragment key={item.field}>
                                                        <Box>
                                                            <Box
                                                                sx={{
                                                                    display: "grid",
                                                                    gridTemplateColumns: "1fr auto 1fr",
                                                                    gap: 3,
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <Box>
                                                                    <Typography
                                                                        sx={{ color: "#525455", fontSize: '18px' }}
                                                                    >
                                                                        {item.title}
                                                                    </Typography>
                                                                    <Typography variant="body2" sx={{ color: "#6B7280", fontSize: '16px' }}>
                                                                        {item.subtitle}
                                                                    </Typography>
                                                                </Box>
                                                                <CustomSwitch
                                                                    // checked={item?.required ? true : formData[item.showField]}
                                                                    checked={formData[item.showField]}
                                                                    onChange={(e) =>
                                                                        handleChange(item.showField, e.target.checked)
                                                                    }
                                                                    disabled={item.required}
                                                                />
                                                                <TextField
                                                                    size="small"
                                                                    value={
                                                                        !formData[item.field]
                                                                            ? item.defaultText
                                                                            : formData[item.field] ?? ""
                                                                    }
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            item.field,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    disabled={!formData[item.field]}
                                                                    placeholder={item.defaultText}
                                                                // sx={{
                                                                //     "& .MuiOutlinedInput-root": {
                                                                //         backgroundColor: formData[item.field]
                                                                //             ? "#FFFFFF"
                                                                //             : "#F3F4F6",
                                                                //         "& fieldset": {
                                                                //             borderColor: "#E5E7EB",
                                                                //         },
                                                                //         "&:hover fieldset": {
                                                                //             borderColor: formData[item.field]
                                                                //                 ? "#B0B9C5"
                                                                //                 : "#E5E7EB",
                                                                //         },
                                                                //         "& input": {
                                                                //             color: formData[item.field]
                                                                //                 ? "#525455"
                                                                //                 : "#9CA3AF",
                                                                //         },
                                                                //     },
                                                                // }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                        {index < 2 && <Divider sx={{ my: 1 }} />}
                                                    </React.Fragment>
                                                ))}
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>
                            </Box>
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {/* Manage Preference */}
                <Accordion sx={{ bgcolor: '#F9FAFB', width: '100%' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '& .MuiAccordionSummary-content': { margin: '4px 0' },
                        }}>
                        <Typography sx={{ fontSize: '18px' }}>
                            Manage Preference
                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Card
                                variant="outlined"
                                sx={{ overflow: "unset" }}
                            >
                                <CardContent sx={{ p: 3, overflow: "unset" }}>
                                    <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                        Privacy Trigger
                                        {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                    </Typography>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        A floating widget for your website to quickly access the consent preferences.
                                    </Typography>
                                    <Stack gap={2}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '2', border: '1px solid #D5D5D5', borderRadius: 1, py: 1, px: 2 }}>
                                            <Typography gutterBottom sx={{ color: "#5F5F5F", m: 0 }}>
                                                Enable Privacy Trigger Position
                                            </Typography>
                                            <CustomSwitch
                                                checked={formData.enablePrivacyTriggerPosition}
                                                onChange={(e) =>
                                                    handleChange('enablePrivacyTriggerPosition', e.target.checked)
                                                }
                                            />
                                        </Box>


                                        <Card sx={{ bgcolor: '#F9FAFB' }}>
                                            <CardContent>
                                                <Typography gutterBottom sx={{ fontSize: '16px' }}>
                                                    Privacy Trigger's Position
                                                    {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "grid",
                                                        gridTemplateColumns: "repeat(2, 1fr)",
                                                        gap: 2,
                                                        width: "100%",
                                                    }}
                                                >
                                                    {['Bottom Left', 'Bottom Right'].map((position) => {
                                                        const isSelected = formData.privacyTriggerPosition === position
                                                        return (
                                                            <Button
                                                                key={position}
                                                                variant="outlined"
                                                                onClick={() => handleChange('privacyTriggerPosition', position)}
                                                                sx={{
                                                                    borderColor: isSelected ? "#F15A29" : "#E5E7EB",
                                                                    backgroundColor: isSelected ? "#ff634814" : "#FFFFFF",
                                                                    "&:hover": {
                                                                        backgroundColor: isSelected ? "#ff634814" : "#F9FAFB",
                                                                        borderColor: isSelected ? "#F15A29" : "#B0B9C5",
                                                                    },
                                                                    textTransform: "none",
                                                                    // height: "50px", // Increased height to accommodate description
                                                                    fontSize: "16px",
                                                                    borderRadius: "8px",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: "4px",
                                                                    padding: "12px",
                                                                    // width: "200px",
                                                                    border: isSelected ? "1px solid #F15A29" : "1px solid #E5E7EB",
                                                                    "&.Mui-selected": {
                                                                        backgroundColor: "#F0FDF9",
                                                                        borderColor: "#F15A29",
                                                                    },
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    component="div"
                                                                    sx={{
                                                                        color: isSelected ? "#F15A29" : "#525455",
                                                                        fontWeight: isSelected ? 600 : 400,
                                                                    }}
                                                                >
                                                                    {/* {position.replace(/([A-Z])/g, " $1").trim()} */}
                                                                    {position}
                                                                </Typography>
                                                            </Button>
                                                        )
                                                    })}
                                                </Box>
                                            </CardContent>
                                        </Card>

                                        <Card sx={{ bgcolor: '#F9FAFB' }}>
                                            <CardContent>
                                                <Typography gutterBottom sx={{ fontSize: '16px' }}>
                                                    Control Level
                                                    {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "grid",
                                                        gridTemplateColumns: "repeat(2, 1fr)",
                                                        gap: 2,
                                                        width: "100%",
                                                    }}
                                                >
                                                    {["Category & Services", "Category Only"].map((level) => {
                                                        const isSelected = formData.controlLevel === level
                                                        return (
                                                            <Box
                                                                key={level}
                                                                sx={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    gap: 1,
                                                                    p: 2,
                                                                    border: "1px solid",
                                                                    borderColor: isSelected ? "#F15A29" : "#E0E0E0",
                                                                    borderRadius: "8px",
                                                                    backgroundColor: isSelected ? "#ff634814" : "#FFFFFF",
                                                                    cursor: "pointer",
                                                                    transition: "all 0.3s ease",
                                                                    flex: 1, // Added to make boxes take equal width
                                                                    "&:hover": {
                                                                        borderColor: isSelected ? "#F15A29" : "#B0B9C5",
                                                                        backgroundColor: isSelected ? "#ff634814" : "#F9FAFB",
                                                                    },
                                                                }}
                                                                onClick={() => handleChange("controlLevel", level)}
                                                            >
                                                                <Typography
                                                                    sx={{
                                                                        color: isSelected ? "#F15A29" : "#525455",
                                                                        fontWeight: 600,
                                                                    }}
                                                                >
                                                                    {level}
                                                                </Typography>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        color: "#6B7280",
                                                                        fontSize: "14px",
                                                                    }}
                                                                >
                                                                    {level === "Category & Services"
                                                                        ? "Visitors can view categories and their services, with granular control to enable or disable services in non-essential categories."
                                                                        : "Visitors can only consent at the category level, without granular control for services within each category."}
                                                                </Typography>
                                                            </Box>
                                                        )
                                                    })}
                                                </Box>
                                            </CardContent>
                                        </Card>

                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '2', border: '1px solid #D5D5D5', borderRadius: 1, py: 1, px: 2 }}>
                                            <Typography gutterBottom sx={{ color: "#5F5F5F", m: 0 }}>
                                                Display Cookies & Services
                                            </Typography>
                                            <CustomSwitch
                                                checked={formData.displayCookiesAndServices}
                                                onChange={(e) =>
                                                    handleChange('displayCookiesAndServices', e.target.checked)
                                                }
                                            />
                                        </Box>
                                    </Stack>
                                </CardContent>
                            </Card>
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {/* Manage preferences content */}
                <Accordion sx={{ bgcolor: '#F9FAFB', width: '100%' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '& .MuiAccordionSummary-content': { margin: '4px 0' },
                        }}>
                        <Typography sx={{ fontSize: '18px' }}>
                            Manage Preferences Content
                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <FormControl fullWidth error={!!errors.managePreferenceContentTitle} sx={{ mb: 2 }}>
                                <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                    Title
                                    <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                </Typography>

                                <TextField
                                    value={formData.managePreferenceContentTitle}
                                    onChange={(e) => handleChange('managePreferenceContentTitle', e.target.value)}
                                    placeholder="We Use Cookies"
                                    variant="outlined"
                                    size="small"
                                    sx={{ bgcolor: '#fff' }}
                                />
                                {errors.managePreferenceContentTitle && <FormHelperText>{errors.managePreferenceContentTitle}</FormHelperText>}
                            </FormControl>

                            <FormControl fullWidth error={!!errors.managePreferenceContentDescription} sx={{ mb: 2 }}>
                                <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                    Description
                                    <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                </Typography>

                                <TextField
                                    value={formData.managePreferenceContentDescription}
                                    onChange={(e) => handleChange('managePreferenceContentDescription', e.target.value)}
                                    placeholder=""
                                    variant="outlined"
                                    size="small"
                                    sx={{ bgcolor: '#fff' }}
                                />
                                {errors.managePreferenceContentDescription && <FormHelperText>{errors.managePreferenceContentDescription}</FormHelperText>}
                            </FormControl>

                            <FormControl fullWidth error={!!errors.managePreferenceContentMoreInformationTitle} sx={{ mb: 2 }}>
                                <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                    More Information Title
                                    <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                </Typography>

                                <TextField
                                    value={formData.managePreferenceContentMoreInformationTitle}
                                    onChange={(e) => handleChange('managePreferenceContentMoreInformationTitle', e.target.value)}
                                    placeholder=""
                                    variant="outlined"
                                    size="small"
                                    sx={{ bgcolor: '#fff' }}
                                />
                                {errors.managePreferenceContentMoreInformationTitle && <FormHelperText>{errors.managePreferenceContentMoreInformationTitle}</FormHelperText>}
                            </FormControl>

                            <FormControl fullWidth error={!!errors.managePreferenceContentMoreInformation} sx={{ mb: 2 }}>
                                <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                    More Information
                                    <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                </Typography>

                                <TextField
                                    value={formData.managePreferenceContentMoreInformation}
                                    onChange={(e) => handleChange('managePreferenceContentMoreInformation', e.target.value)}
                                    placeholder=""
                                    variant="outlined"
                                    size="small"
                                    sx={{ bgcolor: '#fff' }}
                                />
                                {errors.managePreferenceContentMoreInformation && <FormHelperText>{errors.managePreferenceContentMoreInformation}</FormHelperText>}
                            </FormControl>

                            <Typography sx={{ fontSize: '18px' }}>
                                Preferences Modal Layout
                                {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                            </Typography>

                            <Card sx={{ bgcolor: '#fff' }}>
                                <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <Stack>
                                        <Typography gutterBottom sx={{ fontSize: '16px' }}>
                                            Layout
                                            {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(2, 1fr)",
                                                gap: 2,
                                                width: "100%",
                                            }}
                                        >
                                            {["Box", "Bar"].map((level) => {
                                                const isSelected = formData.preferencesModalLayout === level
                                                return (
                                                    <Box
                                                        key={level}
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 1,
                                                            p: 2,
                                                            border: "1px solid",
                                                            borderColor: isSelected ? "#F15A29" : "#E0E0E0",
                                                            borderRadius: "8px",
                                                            backgroundColor: isSelected ? "#ff634814" : "#FFFFFF",
                                                            textAlign: 'center',
                                                            cursor: "pointer",
                                                            transition: "all 0.3s ease",
                                                            flex: 1, // Added to make boxes take equal width
                                                            "&:hover": {
                                                                borderColor: isSelected ? "#F15A29" : "#B0B9C5",
                                                                backgroundColor: isSelected ? "#ff634814" : "#F9FAFB",
                                                            },
                                                        }}
                                                        onClick={() => handleChange("preferencesModalLayout", level)}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: isSelected ? "#F15A29" : "#525455",
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {level}
                                                        </Typography>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: "#6B7280",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            {level === "Box"
                                                                ? "Manage Preference Banner appears as a box in the center of the screen"
                                                                : "Slideover panel that spans the full height of the screen"}
                                                        </Typography>
                                                    </Box>
                                                )
                                            })}
                                        </Box>
                                    </Stack>
                                    <Stack>
                                        <Typography gutterBottom sx={{ fontSize: '16px' }}>
                                            Modal Vertical Alignment
                                            {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(2, 1fr)",
                                                gap: 2,
                                                width: "100%",
                                            }}
                                        >
                                            {["Left", "Right"].map((level) => {
                                                const isSelected = formData.preferencesModalVerticalAlignment === level
                                                return (
                                                    <Box
                                                        key={level}
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 1,
                                                            p: 2,
                                                            border: "1px solid",
                                                            borderColor: isSelected ? "#F15A29" : "#E0E0E0",
                                                            borderRadius: "8px",
                                                            backgroundColor: isSelected ? "#ff634814" : "#FFFFFF",
                                                            textAlign: 'center',
                                                            cursor: "pointer",
                                                            transition: "all 0.3s ease",
                                                            flex: 1, // Added to make boxes take equal width
                                                            "&:hover": {
                                                                borderColor: isSelected ? "#F15A29" : "#B0B9C5",
                                                                backgroundColor: isSelected ? "#ff634814" : "#F9FAFB",
                                                            },
                                                        }}
                                                        onClick={() => handleChange("preferencesModalVerticalAlignment", level)}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: isSelected ? "#F15A29" : "#525455",
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {level}
                                                        </Typography>
                                                    </Box>
                                                )
                                            })}
                                        </Box>
                                    </Stack>
                                </CardContent>
                            </Card>

                            {/* Preferences Modal Buttons */}
                            <Box>
                                <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                    Preferences Modal Buttons
                                    {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                                </Typography>
                                <Card
                                    variant="outlined"
                                    sx={{
                                        border: "1px solid #E5E7EB",
                                        borderRadius: "12px",
                                    }}
                                >
                                    <CardContent sx={{ p: 3 }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                            {/* Customizable Button Sections */}
                                            {[
                                                {
                                                    title: "Accept All",
                                                    subtitle: "Consent to all categories",
                                                    showField: 'preferencesModalButtonShowAcceptAll',
                                                    field: "preferencesModalButtonAcceptAll",
                                                    defaultText: "Accept All",
                                                    required: true,
                                                },
                                                {
                                                    title: "Accept Necessary",
                                                    subtitle: "Consent to only necessary cookie",
                                                    showField: 'preferencesModalButtonShowAcceptNecessary',
                                                    field: "preferencesModalButtonAcceptNecessary",
                                                    defaultText: "Reject All",
                                                    required: true,
                                                },
                                                {
                                                    title: "Save Preferences",
                                                    subtitle: "Show button to save the user's selected preferences.",
                                                    showField: 'preferencesModalButtonShowSavePreferences',
                                                    field: "preferencesModalButtonSavePreferences",
                                                    defaultText: "Save Preferences",
                                                    required: true,
                                                },
                                            ].map((item, index) => (
                                                <React.Fragment key={item.field}>
                                                    <Box>
                                                        <Box
                                                            sx={{
                                                                display: "grid",
                                                                gridTemplateColumns: "1fr auto 1fr",
                                                                gap: 3,
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <Box>
                                                                <Typography
                                                                    sx={{ color: "#525455", fontSize: '18px' }}
                                                                >
                                                                    {item.title}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ color: "#6B7280", fontSize: '16px' }}>
                                                                    {item.subtitle}
                                                                </Typography>
                                                            </Box>
                                                            <CustomSwitch
                                                                // checked={item?.required ? true : formData[item.showField]}
                                                                checked={formData[item.showField]}
                                                                onChange={(e) => handleChange(item.showField, e.target.checked)}
                                                                disabled={item.required}
                                                            />
                                                            <TextField
                                                                size="small"
                                                                value={!formData[item.field] ? item.defaultText : formData[item.field] ?? ""}
                                                                onChange={(e) => handleChange(item.field, e.target.value)}
                                                                disabled={!formData[item.field]}
                                                                placeholder={item.defaultText}
                                                            // sx={{
                                                            //     "& .MuiOutlinedInput-root": {
                                                            //         backgroundColor: formData[item.field]
                                                            //             ? "#FFFFFF"
                                                            //             : "#F3F4F6",
                                                            //         "& fieldset": {
                                                            //             borderColor: "#E5E7EB",
                                                            //         },
                                                            //         "&:hover fieldset": {
                                                            //             borderColor: formData[item.field]
                                                            //                 ? "#B0B9C5"
                                                            //                 : "#E5E7EB",
                                                            //         },
                                                            //         "& input": {
                                                            //             color: formData[item.field]
                                                            //                 ? "#525455"
                                                            //                 : "#9CA3AF",
                                                            //         },
                                                            //     },
                                                            // }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    {index < 2 && <Divider sx={{ my: 1 }} />}
                                                </React.Fragment>
                                            ))}
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Box>
    )
}
